import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import http from "../lib/http";

export default function DealerAdminPage() {

  const navigate = useNavigate();

  const [dealers, setDealers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDealers = async () => {
    try {

      setLoading(true);

      const res = await http.get("/api/dealers");

      const filtered = res.data.filter(
        (d) => !d.isDeleted
      );

      setDealers(filtered);

    } catch (err) {
      console.error("Fetch dealers error:", err);
      alert("Failed to fetch dealers");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDealers();
  }, []);

  // Activate / Deactivate
const toggleStatus = async (id) => {
  try {

    const res = await http.put(
      `/api/dealers/${id}/activate`
    );

    alert(res.data.message);

    fetchDealers();

  } catch (err) {

    console.error(err);

    alert(
      err.response?.data?.error ||
      "Failed to update status"
    );
  }
};

  // Delete
const deleteDealer = async (id) => {

  const confirmDelete = window.confirm(
    "Are you sure you want to delete this dealer?"
  );

  if (!confirmDelete) return;

  try {

    const res = await http.patch(
      `/api/dealers/${id}/delete`
    );

    alert(res.data.message);

    fetchDealers();

  } catch (err) {

    console.error(err);

    alert(
      err.response?.data?.error ||
      "Delete failed"
    );
  }
};

const getDaysLeft = (expiryDate) => {

  if (!expiryDate) return "-";

  const days = Math.ceil(
    (new Date(expiryDate) - new Date()) /
    (1000 * 60 * 60 * 24)
  );

  return days;
};

const renewSubscription =
  async (dealerId) => {

    const plan = prompt(
      "Enter Plan:\nMONTHLY\nQUARTERLY\nYEARLY"
    );

    if (!plan) return;

    try {

      await http.put(
        `/api/dealers/${dealerId}/subscription`,
        {
          plan:
            plan.toUpperCase(),

          amountPaid:
            plan === "YEARLY"
              ? 9999
              : plan === "QUARTERLY"
              ? 2499
              : 999,

          paymentMethod: "CASH"
        }
      );

      alert(
        "Subscription Updated"
      );

      fetchDealers();

    } catch (err) {

      console.error(err);

      alert(
        "Failed to update subscription"
      );

    }
};


  return (
    <div>

      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">

        <div>
          <h2 className="fw-bold mb-1">
            Dealer Management
          </h2>

          <p className="text-muted mb-0">
            Manage dealer approvals and accounts
          </p>
        </div>

        <button
          className="btn btn-primary"
          onClick={() => navigate("/admin/add-dealer")}
        >
          + Add Dealer
        </button>

      </div>

      {/* Card */}
      <div className="card border-0 shadow-sm">

        <div className="card-body">

          {loading ? (

            <div className="text-center py-5">
              <div className="spinner-border text-primary"></div>
            </div>

          ) : dealers.length === 0 ? (

            <div className="text-center py-5 text-muted">
              No dealers found
            </div>

          ) : (

            <div className="table-responsive">

              <table className="table align-middle">

                <thead className="table-light">

                  <tr>
                    <th>Dealer</th>
                    <th>Category</th>
                    <th>Contact</th>
                    <th>Status</th>
                    <th>Plan</th>
                    <th>Expiry</th>
                    <th>Days Left</th>
                    <th width="320">Actions</th>
                  </tr>

                </thead>

                <tbody>

                  {dealers.map((dealer) => (

                    <tr key={dealer._id}>

                      <td>

                        <div className="d-flex align-items-center gap-3">

                          <img
                            src={
                              dealer.image
                                ? `http://localhost:5000${dealer.image}`
                                : "https://via.placeholder.com/50"
                            }
                            alt={dealer.name}
                            style={{
                              width: "55px",
                              height: "55px",
                              borderRadius: "12px",
                              objectFit: "cover",
                            }}
                          />

                          <div>

                            <div className="fw-semibold">
                              {dealer.name}
                            </div>

                            <small className="text-muted">
                              {dealer.locationName}
                            </small>

                          </div>

                        </div>

                      </td>

                      <td>

                        <span className="badge bg-light text-dark border">
                          {dealer.category}
                        </span>

                      </td>

                      <td>
                        {dealer.contact}
                      </td>

                      <td>

                        {dealer.isActive ? (
                          <span className="badge bg-success">
                            Active
                          </span>
                        ) : (
                          <span className="badge bg-warning text-dark">
                            Pending
                          </span>
                        )}

                      </td>

                      <td>
                        <span className="badge bg-info">
                          {dealer.subscription?.plan || "TRIAL"}
                        </span>
                      </td>

                      <td>
                        {dealer.subscription?.expiryDate
                          ? new Date(
                              dealer.subscription.expiryDate
                            ).toLocaleDateString()
                          : "-"
                        }
                      </td>

                      <td>
                        {(() => {

                          const days =
                            getDaysLeft(
                              dealer.subscription?.expiryDate
                            );

                          if (days < 0) {
                            return (
                              <span className="badge bg-danger">
                                Expired
                              </span>
                            );
                          }

                          if (days <= 7) {
                            return (
                              <span className="badge bg-warning text-dark">
                                {days} Days
                              </span>
                            );
                          }

                          return (
                            <span className="badge bg-success">
                              {days} Days
                            </span>
                          );

                        })()}
                      </td>    
                      <td>

                        <div className="d-flex gap-2 flex-wrap">

                          <button
                            className={`btn btn-sm ${
                              dealer.isActive
                                ? "btn-outline-warning"
                                : "btn-outline-success"
                            }`}
                            onClick={() =>
                              toggleStatus(dealer._id)
                            }
                          >
                            {dealer.isActive
                              ? "Deactivate"
                              : "Approve"}
                          </button>

                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() =>
                              navigate(`/admin/edit-dealer/${dealer._id}`)
                            }
                          >
                            Edit
                          </button>

                           <button
                            className="btn btn-sm btn-outline-success"
                            onClick={() =>
                              renewSubscription(
                                dealer._id
                              )
                            }
                          >
                            Renew
                          </button> 

                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() =>
                              deleteDealer(dealer._id)
                            }
                          >
                            Delete
                          </button>

                        </div>

                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          )}

        </div>

      </div>

    </div>
  );
}